const membersStrings = {
  memberProfile: {
    blockUser: 'Block User',
    unblockUser: 'Unblock User',
    points: 'points',
    awardPoints: 'Award Points',
    deductPoints: 'Deduct Points',
    award: 'Award',
    deduct: 'Deduct',
    reason: 'Reason',
    addReason: 'Add reason',
    block: 'Block',
    unblockTitle: 'Are you sure you want unblock',
    selectCategory: 'Select Category',
    requiredField: 'Required field',
    wrongField: 'Wrong field',
    outOfLimitPoiints: 'You exceeded the maximum number of points',
    blockedUser: 'Blocked User',
    allTransactions: 'All Transactions',
    earnedTransactions: 'Earned Transactions',
    redeemedTransactions: 'Redeemed Transactions',
    transactionID: 'Transaction #',
    date: 'Date',
    type: 'Type',
    catogory: 'Catogory',
    expiryDate: 'Expiry Date',
    expiredPoints: 'Expired Points',
    phoneNumber: 'Phone Number',
    awardSuccessMessage: (points, user) => `You successfully awarded +${points} points to ${user}`,
    deductSuccessMessage: (points, user) =>
      `You successfully deducted -${points} points from ${user}`,
    blockSucessMessage: user => `You successfully blocked ${user}`,
    unblockSucessMessage: user => `You successfully unblocked ${user}`,
    failMessage: 'There is some failure in completing your request',
  },

  memberTransactions: {
    gridHeaderList: {
      id: 'transactionID',
      date: 'date',
      points: 'points',
      type: 'Type',
      catogory: 'Catogory',
      expiryDate: 'Expiry Date',
      expiredPoints: 'Expired Points',
    },
  },

  membersComponent: {
    addMembr: 'Add Memebr',
  },

  membersList: {
    emptyStateText: 'There are no matches for your search',
    emptyStateSubText: 'Try searching with another mobile number',
    gridHeaderList: {
      member: 'Member',
      points: 'Points',
    },
  },
};

export default membersStrings;
